<div class="jumbotron jumbotron-fluid" style="background-image: url('assets/img/tablet.jpg');">
	<div class="bg-opacity"></div>
	<a href="/StatusBoxComponent"><i class="material-icons arrow-back">keyboard_backspace</i></a>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="text-center">
  					<h1 class="display-4">Acciones del box</h1>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="container">
	<div class="row">
		<div class="col-12">			
			<div class="btn-wrapper-status">
				<a href="#" class="btn btn-primary btn-lg btn-status">Open Front Door</a>
				<a href="#" class="btn btn-primary btn-lg btn-status">Close Front Door</a>
				<a href="#" class="btn btn-primary btn-lg btn-status">Open Back Door</a>
				<a href="#" class="btn btn-primary btn-lg btn-status">Force Stop</a>
			</div>
		</div>		
	</div>
</div>